import { initLayout } from '../layout.js';
import { initPageHeader } from '../sections/page-header.js';

document.addEventListener('DOMContentLoaded', () => {
    initLayout();
    initPageHeader();
})
